<template>
    <div class="map-button-round">
        <button class="button is-info is-outlined"
                @click="activate"
                title="Слои" :class="{'is-active' : isActive}">
            <span class="icon">
                <img v-if="isActive" src="../../../assets/svg/layers-button-active.svg"/>
                <img v-else src="../../../assets/svg/layers-button.svg"/>
            </span>
        </button>
        <right-panel v-show="isActive">
            <catalogs-panel></catalogs-panel>
        </right-panel>
    </div>
</template>
<script>
	import RightPanel from "../RightPanel";
	import CatalogsPanel from "../catalogs/CatalogsPanel";

	export default {
		components: {
			RightPanel,
			CatalogsPanel
		},
        data(){
			return{
			    isActive:false	
            };
        },
		methods: {					
            activate(){
				this.isActive = !this.isActive;
				this.$emit('activated', this);
            }
		}		
	};
</script>